import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { RouteComponentProps, Redirect } from 'react-router'
import { TripStatuses } from '../../constants/trip-statuses'
import { IActiveTripResponseV2, ITripEdit } from '../../types'
import Modal from '../ui/Modal'
import ManualTripCompleteForm from './ManualTripCompleteForm'
import UIMessages from '../../utils/ui-messages'

interface IRouteParams {
  tripId: string
}

interface IManualTripCompleteModalProps extends RouteComponentProps<IRouteParams> {
  currentTrip: IActiveTripResponseV2
  loading: boolean
  completeTripManually: (
    tripId: string,
    paymentRequired: boolean,
    tripPrice?: number,
    comment?: string,
    disableNotification?: boolean
  ) => Promise<any>
  close: () => void
  saveData: (params: ITripEdit) => Promise<any>
}

export default class ManualTripCompleteModal extends React.Component<IManualTripCompleteModalProps> {
  public render() {
    const currentTripStatus = this.props.currentTrip.lastStatus
    const tripStatus = currentTripStatus

    if (
      tripStatus === TripStatuses.COMPLETED ||
      // tripStatus === TripStatuses.CANCELLED ||
      tripStatus === TripStatuses.MANUALLY_COMPLETED
    ) {
      return <Redirect to={`/trips/${this.props.currentTrip.id}`} />
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-4 p2'>
            <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>
              {UIMessages.manualTripComplete.modalTitle}
            </span>
            <div className='mt1'>
              <ManualTripCompleteForm
                currentTrip={this.props.currentTrip}
                onSubmit={this.onSubmit}
                loading={this.props.loading}
              >
                <button
                  type='button'
                  onClick={this.props.close}
                  className='CancelButton btn bg-white rounded font-light-grey mr2'
                >
                  {UIMessages.common.cancel}
                </button>
                <button
                  type='submit'
                  className='SubmitButton btn bg-green rounded font-white weight-300'
                  disabled={this.props.loading}
                >
                  <span className='flex items-center'>
                    Submit
                    {this.props.loading ? (
                      <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
                    ) : (
                      <React.Fragment />
                    )}
                  </span>
                </button>
              </ManualTripCompleteForm>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private onSubmit = async (
    tripId: string,
    paymentRequired: boolean,
    tripPrice?: number,
    comment?: string,
    disableNotification?: boolean
  ) => {
    try {
      //Audit Trail
      const params: ITripEdit = {
        prevNotes: this.props.currentTrip.lastStatus
      }
      await this.props.saveData(params)
      await this.props.completeTripManually(tripId, paymentRequired, tripPrice, comment, disableNotification)
    } catch (e) {
      console.error('Problem manually completing trip')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/ManualTripCompleteModal.tsx